import React, { PropsWithChildren } from "react";

import "./busy-blocker.css";

export const BusyBlocker = ({
	isOpen,
}: PropsWithChildren<{
	isOpen: boolean;
}>) => (
	<>
		<div className={`busy-blocker ${isOpen ? "busy-blocker--open" : ""}`}>
			<div className="busy-blocker__dots">
				<div className="busy-blocker__dot" />
				<div className="busy-blocker__dot" />
				<div className="busy-blocker__dot" />
				<div className="busy-blocker__dot" />
			</div>
		</div>
	</>
);

BusyBlocker.displayName = "BusyBlocker";
